import { render, staticRenderFns } from "./SaleDefault.vue?vue&type=template&id=78a7aff0"
import script from "./SaleDefault.vue?vue&type=script&lang=ts"
export * from "./SaleDefault.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a7aff0')) {
      api.createRecord('78a7aff0', component.options)
    } else {
      api.reload('78a7aff0', component.options)
    }
    module.hot.accept("./SaleDefault.vue?vue&type=template&id=78a7aff0", function () {
      api.rerender('78a7aff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SaleDefault.vue"
export default component.exports